import { memo } from "react";
import { BzHeading, BzModal, BzModalBody, BzModalHeader } from '../../components';
import { Row, Col, Container } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal } from "../../redux/actions/modals"


const KeyboardShortcuts = () => {

    const dispatch = useDispatch()

    const modals = useSelector(state => state?.modals?.modals)

    const handleClose = () => {
        dispatch(handleModal([{ "KEYBOARD_SHORTCUTS": false }]))
    }

    return (
        <>
            <BzModal size='xl' show={modals['KEYBOARD_SHORTCUTS']} onHide={handleClose} centered>
                <BzModalHeader className='modaltabs-header modal-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={9} className='d-flex justify-content-start align-self-center'>
                                <BzHeading className='font-medium font-size4 color-text'>Keyboard Shortcuts</BzHeading>
                            </Col>
                            <Col md={3} className='d-flex justify-content-end align-self-center'>
                                <div onClick={handleClose} className='icon-16 icon-close icon-dark'></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>

                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mt-3'>
                            <Col>
                                <Row className='g-0 mb-4'>
                                    <Col md={8}>
                                            <BzHeading className='font-medium font-size5 color-text'>Function</BzHeading>
                                    </Col> 
                                    <Col>
                                        <BzHeading className='font-medium font-size5 color-text'>Shortcut Key</BzHeading>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                        <div className='font-regular font-size3 color-text'>Login</div>
                                    </Col> 
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>F9</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                        <div className='font-regular font-size3 color-text'>Logout</div>
                                    </Col> 
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>F10</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                        <div className='font-regular font-size3 color-text'>Lock Application</div>
                                    </Col> 
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>Ctrl + W</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Exit</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>Alt + F4</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Market Watch Profile</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>F4</div>
                                    </Col>
                                    </Row>
                                <Row className='g-0 mb-3'>
                                <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Market Watch Group Settings</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>Ctrl + G</div>
                                    </Col>
                                    </Row>
                                <Row className='g-0 mb-3'>
                                <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Buy Order Entry</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>F1</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Sell Order Entry</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>F2</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Order Book</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>F3</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Trade Book</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>F8</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Net Positions</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>Alt + F6</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Order History</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>Shift + F12</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>View Holdings/ Collateral Values</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>Alt + F9</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                            <div className='font-regular font-size3 color-text'>Update Holdings/ Collateral Values</div>
                                    </Col> 
                                    <Col>
                                            <div className='font-regular font-size3 color-text'>Ctrl + F9</div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={1}>&nbsp;</Col>
                            <Col>
                                <Row className='g-0 mb-4'>
                                    <Col md={8}>
                                        <BzHeading className='font-medium font-size5 color-text'>Function</BzHeading>
                                    </Col> 
                                    <Col>
                                        <BzHeading className='font-medium font-size5 color-text'>Shortcut Key</BzHeading>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                        <div className='font-regular font-size3 color-text'>Net Positions</div>
                                    </Col> 
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>Alt + F6</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                        <div className='font-regular font-size3 color-text'>Order History</div>
                                    </Col> 
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>Shift + F12</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                        <div className='font-regular font-size3 color-text'>View Holdings/ Collateral Values</div>
                                    </Col> 
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>Alt + F9</div>
                                    </Col>
                                </Row>
                                <Row className='g-0 mb-3'>
                                    <Col md={8}>
                                        <div className='font-regular font-size3 color-text'>Update Holdings/ Collateral Values</div>
                                    </Col> 
                                    <Col>
                                        <div className='font-regular font-size3 color-text'>Ctrl + F9</div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                </Container>
                </BzModalBody>
            </BzModal>
        </>
    );
};

export default memo(KeyboardShortcuts);